export default {
    namespaced: true,
    state: {
        fetchData: '',
        user: '',
        password: '',
        quant: 1,
        annexation: 0,
        mainPrice: 0,
        crossflag: false,
        interface: null,
        companyid: -1,
        is_quarter: false
    },
    mutations: {
        setUserInfo(state, payload) {
            state.user = payload.user
            state.password = payload.password
            state.fetchData = payload.fetchData
        },
        setQuant(state, payload) {
            state.quant = payload
        },
        setPrice (state, payload) {
            state.annexation = payload
        },
        setCrossFlag (state,payload) {
            state.crossflag = payload
        },
        setMainPrice (state, payload) {
            state.mainPrice = payload
        },
        setInterface (state, payload) {
            state.interface = payload
        },
        setCompanyID (state, payload) {
            state.companyid = payload
        },
        setQuarterMode(state, val) {
            state.is_quarter = val
        }
    },
    getters: {

    },
    actions: {},
    modules: {

    }
}